<div class="chart-footer">
  <div class="row">
    <div class="col-sm-5 col-6 col flex-justify-start">
      <div class="title" i18n="@@dashboard-footer.dashboardOptionsFilterBy">Show</div>
      <div class="input_container radio-filter-by" [class.multi-line]="multiLine">
        <ng-template
          [ngTemplateOutlet]="radioFilter"
          [ngTemplateOutletContext]="{
            items: inputs,
            symbol: currency ,
            model: filterBy,
            subject: radioSubject
          }"
        ></ng-template>
        <ng-template #radioFilter let-items="items" let-symbol="symbol" let-model="model" let-subject="subject">
          <div *ngFor="let item of items" class="input-item">
            <input
              class="filter-by radio-filter-adjustment"
              id="{{ 'radio-' + item.value }}"
              name="radio-filter"
              type="radio"
              value="{{ item.value }}"
              [ngModel]="model"
              (ngModelChange)="subject?.next($event)"
            />
            <label for="{{ 'radio-' + item.value }}">{{ item.label }} {{ 'value' === item.value ? symbol : '' }}</label>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col-sm-5 col-6 col dashboard-download-links" [ngClass]="{'opacity-25 pe-none': isSalesView === true}">
      <ng-container *ngIf="hasData">
        <div class="text-end title" i18n="@@dashboard-footer.dashboardDownload">
          Download
        </div>
        <div class="text-end">
          <a class="download-button" id="downloadDashboard" (click)="renderFile('pdf')">
            <svg style="width: 23px; height: 22px;">
              <use href="/assets/images/svg_ico/icons.svg#ic_download"></use>
            </svg>
            <span>Pdf</span>
          </a>
          <a *ngIf="featureToggle" class="download-button" (click)="downloadCsvFile()">
            <svg style="width: 23px; height: 22px;">
              <use href="/assets/images/svg_ico/icons.svg#ic_download"></use>
            </svg>
            <span>Csv</span>
          </a>
        </div>
      </ng-container>
    </div>
    <div class="col-sm-2 col-12 col flex-justify-end dashboard-print-container">
      <div class="print-btn" (click)="print()" [ngClass]="{'opacity-25 pe-none': isSalesView === true}">
        <span class="title" i18n="@@dashboard-footer.buttonPrint">Print</span>
        <svg style="width: 24px; height: 24px;">
          <use href="/assets/images/svg_ico/icons.svg#ic_print"></use>
        </svg>
      </div>
    </div>
  </div>
</div>
<div *ngIf="hasData" class="message data-disclaimer">
  <p i18n="@@dashboard-footer.dashboardDataDisclaimer">
    Data is presented in your dashboard for quick reference, but is not a reference for billing purposes.
  </p>
</div>
<spinner *ngIf="renderingFile" fixed="true"></spinner>
